import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'react-materialize';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../../functions/logging';

import '../../static/home/ListItem.css';
import placeholderIcon from '../../assets/home/list-item-placeholder.png';

import { groupJoinSubscription, groupSubscribe } from '../../api/group';

import PageLoader from '../global/PageLoader';

import * as authFns from '../../functions/auth';
import * as rewardsFns from '../../functions/rewards';
import * as studyFns from '../../functions/study';
import * as timeFns from '../../functions/time';

import localeMessages from '../../locales/listItems';

/* Google analytics */
import ActionStatus from '../../analytics/analytics-events/ActionStatus';
import { ActionStatusEvent } from '../../analytics/analytics-events/constants';

import {
	setFetchedEpisode,
	setFetchedGroup,
	setFetchedGroupPanelSegment,
	addStudyToMyList
} from '../../redux/actions/index';
import { enableFullscreen } from '../../functions/fullscreen';

// const timeout = ms => new Promise(res => setTimeout(res, ms));

class ListItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			working: false,
			errors: {}
		};

		this.joinStudy = this.joinStudy.bind(this);
		this.completeStudy = this.completeStudy.bind(this);
	}

	async joinGroup() {
		Logger.log(this.constructor.name, "joinGroup()", this.props.item.video_id, this.props.item._id);
		this.setState({ working: true });
		try {
			let panelSegment = 0;
			let user_id = this.props.currentUser && this.props.currentUser.user_id ? this.props.currentUser.user_id : null;
			const result = await groupJoinSubscription(authFns.getToken(), user_id, this.props.item.video_id, this.props.item._id, panelSegment);

			Logger.log(this.constructor.name, "joinGroup() result", result);
			if (result) {
				this.setState({ errors: {}, working: false });
			}
			else {
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_group_join_failed);
				this.setState({ errors: errors, working: false });
			}
			return result;
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "joinGroup() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_group_join_failed);
			this.setState({ errors: errors, working: false });
		}
	}

	async subscribeToGroup() {
		Logger.log(this.constructor.name, "subscribeToGroup()", this.props.item.video_id, this.props.item._id);
		this.setState({ working: true });
		try {
			let panelSegment = 0;
			let user_id = this.props.currentUser && this.props.currentUser.user_id ? this.props.currentUser.user_id : null;
			const result = await groupSubscribe(authFns.getToken(), user_id, this.props.item.video_id, this.props.item._id, panelSegment);

			// const result = true;
			// await timeout(1000);

			Logger.log(this.constructor.name, "subscribeToGroup() result", result);
			if (result) {

				let actionStatus = new ActionStatus(ActionStatusEvent.JOIN_PILOT, '', '', false, false, true);
				actionStatus.video_id = this.props.item.video_id;
				actionStatus.view = 'ListItem';
				actionStatus.gaTracker = this.props.tracker;
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);	

				this.props.addStudyToMyList(this.props.item);
				this.setState({ errors: {}, working: false });
			}
			else {
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_group_join_failed);
				this.setState({ errors: errors, working: false });
			}
			return result;
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "subscribeToGroup() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_group_join_failed);
			this.setState({ errors: errors, working: false });
		}
	}

	getDigitClass(numberString) {
		let stringLength = numberString.length;
		switch (stringLength) {
			case 3:
				return " triple-digits";
			case 2:
				return " double-digits";
			default:
				return "";
		}
	}

	joinStudy() {
		Logger.log(this.constructor.name, "joinStudy()");
		const result = this.subscribeToGroup();
		Logger.log(this.constructor.name, "joinStudy() result", result);
	}

	async completeStudy() {
		Logger.log(this.constructor.name, "completeStudy()", this.props.item);
		/* Google analytics event */
		let actionStatus = new ActionStatus(ActionStatusEvent.WATCH_PILOT_NOW, '', '', false, false, true);
		actionStatus.video_id = this.props.item.video_id;
		actionStatus.gaTracker = this.props.tracker;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);	

		const panelSegmentIndex = this.props.item && this.props.item.panel_segment_index ? this.props.item.panel_segment_index : 0;

		this.props.setFetchedGroup(this.props.item);
		this.props.setFetchedGroupPanelSegment(panelSegmentIndex);
		this.props.setFetchedEpisode(this.props.item.content);
		if (studyFns.hasMpaaRating(this.props.item.content)) {
			this.props.history.push("/mpaa");
		}
		else {
			//The Web API requestFullscreen() just works when executed by a user interaction. Click or touch.
			await enableFullscreen();
			this.props.history.push("/study");
		}
	}

	renderThumbnail() {
		let imageUrl = null;

		const item = this.props.item;
		if (item.artwork && item.artwork.length) {
			if (item.artwork[0].background) {
				imageUrl = item.artwork[0].background;
			}
			else if (item.artwork[0].poster) {
				imageUrl = item.artwork[0].poster;
			}
			else if (item.artwork[0].background_mobile) {
				imageUrl = item.artwork[0].background_mobile;
			}
		}

		if (!imageUrl) {
			return <ThumbnailPlaceholder index={this.props.index} />;
		}

		return (
			<img className='pilotly-list-item-thumbnail-image' src={imageUrl} alt={item.title} />
		);
	}

	renderButton() {
		let buttonText = "Join Study";
		let buttonClass = "pilotly-list-item-actions-button ";
		let buttonFn = this.joinStudy;

		const item = this.props.item;

		if (studyFns.hasUserCompleted(item)) {
			buttonText = this.props.intl.formatMessage(localeMessages.completed);
			buttonClass = "transparent " + buttonClass + "pilotly-list-item-actions-button-completed form-lock";
			buttonFn = null;
		}
		else if ((studyFns.userHasInList(item) || studyFns.hasUserJoined(item)) && studyFns.isPastEndDate(item)) {
			buttonText = this.props.intl.formatMessage(localeMessages.expired);
			buttonClass = "transparent " + buttonClass + "pilotly-list-item-actions-button-expired form-lock";
			buttonFn = null;
		}
		else if (studyFns.userHasInList(item) || studyFns.hasUserJoined(item)) {
			buttonClass = "transparent " + buttonClass + "pilotly-list-item-actions-button-watch";
			buttonFn = this.completeStudy;

			if (studyFns.inProgress(item)) {
				buttonText = this.props.intl.formatMessage(localeMessages.complete_study);
			}
			else {
				buttonText = this.props.intl.formatMessage(localeMessages.watch_now);
			}
		}
		else {
			buttonClass += "pilotly-list-item-actions-button-join";
		}

		return (
			<Button large waves='light' className={buttonClass}
				onClick={() => buttonFn()}
			>
				{buttonText}
			</Button>
		);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		const item = this.props.item;

		let duration = "";
		if (item.content && item.content.duration) {
			duration = timeFns.formatDuration(item.content.duration);
		}

		let title = item.title;
		if (item.study_name) {
			title = item.study_name;
		}

		let rewardPoints = rewardsFns.calculatePoints(item);
		let digitClass = this.getDigitClass(rewardPoints.toString());
		let displayProgressBar = studyFns.userHasInList(item) || studyFns.hasUserJoined(item);

		const endDate = moment(item.end_date).format("MMM Do"); // INTL:DATE

		return (
			<div className="pilotly-list-item pilotly-clearfix">
				<PageLoader addedClass="pilotly-blue-background" loading={this.state.working} small={true} />
				<div className="pilotly-list-item-thumbnail">
					{this.renderThumbnail()}

					<div className={"pilotly-list-item-progress offOnTrans" + (displayProgressBar ? " on" : "")}>
						{/* Progress goes here */}
						<div className="pilotly-list-item-completion-bar">
						</div>
					</div>
				</div>
				
				<div className="pilotly-list-item-info">
					<div className="pilotly-list-item-points">
						<div className="pilotly-list-item-points-circle">
							<span className={"pilotly-points-count pilotly-list-item-points-count" + digitClass}>
								{rewardPoints}
							</span>
							<span className={"pilotly-points-suffix pilotly-list-item-points-suffix" + digitClass}>
								pp
							</span>
						</div>
					</div>
					<div className="pilotly-list-item-details">
						<div className="pilotly-list-item-title">
							{title}
						</div>
						<div className="pilotly-list-item-time">
							<div className="pilotly-list-item-end-date">
								<FormattedMessage
									id="listitem.end_date"
									defaultMessage={`Ends {endDate}`}
									values={{ endDate: endDate }}
								/>
							</div>
							<div className="pilotly-list-item-time-remaining">
								<FormattedMessage
									id="listitem.runtime"
									defaultMessage={`Runtime {duration}`}
									values={{ duration: duration }}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="pilotly-list-item-actions">
					{this.renderButton()}
				</div>
			</div>
		);
	}
}

class ThumbnailPlaceholder extends Component {
	render() {
		const index = this.props.index || this.props.index === 0 ? this.props.index : Math.floor(Math.random() * 4);
		const bgClassName = "pilotly-list-item-thumbnail-placeholder-" + (index + 1);
		return (
			<div className={"pilotly-list-item-thumbnail-placeholder " + bgClassName}>
				<div>
					{/* <i className="fas fa-video pilotly-list-item-thumbnail-placeholder-icon"></i> */}
					<img className="pilotly-list-item-thumbnail-placeholder-image" src={placeholderIcon} alt="Watch Now" />
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setFetchedEpisode,
		setFetchedGroup,
		setFetchedGroupPanelSegment,
		addStudyToMyList
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ListItem));



// WEBPACK FOOTER //
// ./src/components/home/ListItem.js